import {
  BookOpen,
  Monitor,
  GraduationCap,
  Radio,
  ClipboardCheck,
  Handshake,
  Users,
  BarChart3,
  Compass,
} from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { NeonButton } from "@/components/Buttons";
import { scrollToId } from "@/lib/ui";

const ITEMS = [
  { icon: BookOpen, title: "P.E.E. GAME PLAN TRAINING", desc: "Learn the complete Position • Event • Entry trading methodology." },
  { icon: Monitor, title: "P.E.E. OS ACCESS", desc: "Access the technology built specifically around the P.E.E. execution process." },
  { icon: GraduationCap, title: "EXECUTOR TRAINING", desc: "Develop the discipline and decision-making required to follow the Game Plan." },
  { icon: Radio, title: "LIVE COACHING", desc: "Scheduled sessions focused on P.E.E., execution, review, and trader development." },
  { icon: ClipboardCheck, title: "TRADE REVIEW", desc: "Break down trading decisions against the Game Plan and execution process." },
  { icon: Handshake, title: "ACCOUNTABILITY", desc: "Build measurable standards around following your rules." },
  { icon: Users, title: "PRIVATE COMMUNITY", desc: "Train alongside traders committed to execution over prediction." },
  { icon: BarChart3, title: "P.E.E. ANALYTICS", desc: "Study P.E.E. data and execution patterns over time." },
  { icon: Compass, title: "EXECUTOR DEVELOPMENT", desc: "Track progress toward becoming a more disciplined, process-driven trader." },
];

export default function CommunityV2() {
  return (
    <section id="community" data-testid="community-section" className="py-24 lg:py-32">
      <span id="training" className="block h-0" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="08 — Community"
          testid="community-heading"
          title={
            <>
              Execution is a skill.
              <br />
              We build <span className="glow-text-neon text-neon">Executors.</span>
            </>
          }
          description="Execution Traders Community is the training and development environment surrounding P.E.E. Members learn the Game Plan, gain access to P.E.E. OS technology, develop execution discipline, review trades, study analytics, receive coaching, and improve alongside traders committed to the same standard."
        />

        <div className="mt-12 space-y-3">
          {[
            { text: "The Game Plan teaches the trade.", tone: "text-white" },
            { text: "The OS organizes the trade.", tone: "text-white" },
            { text: "The community develops the trader.", tone: "glow-text-neon text-neon" },
          ].map((l, i) => (
            <Reveal key={l.text} delay={0.1 * i}>
              <div className={`font-display text-xl font-extrabold uppercase tracking-tight sm:text-3xl ${l.tone}`}>
                {l.text}
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {ITEMS.map((c, i) => (
            <Reveal key={c.title} delay={0.04 * i} className="h-full">
              <div
                data-testid={`community-card-${i}`}
                className="group h-full rounded-lg border border-line bg-charcoal p-6 transition-colors duration-500 hover:border-neon/45"
              >
                <c.icon size={18} className="text-neon" />
                <h3 className="mt-4 font-mono text-xs font-semibold uppercase tracking-[0.16em] text-white">
                  {c.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-mist">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 text-center">
            <NeonButton testid="community-join-button" onClick={() => scrollToId("pricing")}>
              Join Execution Traders
            </NeonButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
